import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout/index'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// context
import { ApiTokensPageContext } from 'containers/ApiTokens/layers/API'
// view components
import ApiTokensTable from './components/Table'
import CreateAPITokenButton from 'components/CTAs/CreateAPIToken'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const ApiTokens: React.FC = () => {
  const { isLoading } = React.useContext(ApiTokensPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - API Settings</title>
      </Helmet>
      <MainLayoutContainer CTA={<CreateAPITokenButton />} isLoading={isLoading}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <ApiTokensTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default ApiTokens
